<template>
  <span
    v-if="type"
    class="inline-flex w-8 h-8 items-center justify-center rounded-full border text-sm font-bold flex-shrink-0"
    :class="type === 'self' ? 'bg-violet-50 text-violet-700 border-violet-100' : 'bg-teal-50 text-teal-700 border-teal-100'"
    :title="label"
  >
    <span v-if="type === 'mixed'" aria-hidden="true" class="flex flex-col text-[11px] leading-[11px]">
      <span>公</span><span>自</span>
    </span>
    <span v-else aria-hidden="true">{{ type === 'self' ? '自' : '公' }}</span>
    <span class="sr-only">{{ label }}</span>
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { VaccineType } from '../types'

const props = defineProps<{ type?: VaccineType }>()
const label = computed(() =>
  props.type === 'self' ? '自費' : props.type === 'public' ? '公費' : '公費／自費，請查看疫苗資訊'
)
</script>
